/**
 * 应用入口（架构 §2 src/main.tsx / T03 / T01）
 *  - 挂载 React + 主题模式 Provider（明暗切换）+ CssBaseline + React Router + LocaleProvider（U2 i18n）
 *  - 主题由 ThemeModeProvider 接管（读 localStorage 默认 light，切换写回），包裹 MUI ThemeProvider。
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ThemeModeProvider } from './theme/ThemeModeProvider';
import { LocaleProvider } from './i18n';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ThemeModeProvider>
      <CssBaseline />
      <LocaleProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </LocaleProvider>
    </ThemeModeProvider>
  </React.StrictMode>,
);
